import { Component, HostListener, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { SharedServices } from '../../../../../services/shared.services'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl, getThumbnail } from '../../../../../../helper/common'
import { ActivatedRoute } from '@angular/router'
import * as moment from 'moment'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { notification } from 'onsenui'

@Component({
    selector: 'app-modal-client-detail-top-simulation',
    templateUrl: './modal-client-detail-simulation.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-simulation.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailSimulationComponent implements OnInit {
    en: any = {}
    showEN: Boolean = true
    option_Simulation: String = 'hidden'
    TabSimulationClass: any

    arrTabSimulation: any[] = []
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0
    senMax: any = 100
    max: any = 0
    uploadImageForm: FormGroup
    indexNow: any = 0
    arrShowStatus: any[] = []
    idClient: any
    resourceUrl = 'resource'
    JsonSimulation: any = {}
    arrSimulation: any[] = []
    isLoading: Boolean = false
    animationDuration: any = 300

    arrVideo: any[] = []
    length: any
    durationTime: any

    arrayTimeSendMail
    displaySendAtText = ''
    oldHeight: any
    oldWidth: any
    urlThumbail = ''

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private route: ActivatedRoute,
                public matrixServices: MatrixServices,
                private clientTopServices: ClientTopServices) {
        this.option_Simulation = 'active'
        this.TabSimulationClass = 'option_0'
        this.arrShowStatus = [false]
        this.indexNow = 0
        this.route.parent.paramMap.subscribe(params => {
            if (params.get('id') != '') {
                this.idClient = params.get('id') ? params.get('id') : ''
                this.getSimalation(this.idClient)
            }
        })
    }

    ngOnInit() {
        this.uploadImageForm = this.formBuider.group({
            inputImage: new FormControl(''),
        })
        this.width = ($(window).width() - 300) * 4 / 5
        this.height = 9 * this.width / 16
        this.resizeUser()
        this.resizeFullScreen()
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) * 4 / 5
                        this.height = this.width * 9 / 16
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200)
                        this.width = this.height * 16 / 9
                    }
                }
            }
        })
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            if (status != null && status['status'] != undefined) {
                const tmp: any = status['status']
                if (tmp == 'in') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) * 4 / 5
                        this.height = this.width * 9 / 16
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500)
                        this.width = this.height * 16 / 9
                    } else {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500)
                        this.width = this.height * 16 / 9
                    }
                } else {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) * 4 / 5
                        this.height = this.width * 9 / 16
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 300)
                        this.width = this.height * 16 / 9
                    }
                }
                this.oldHeight = this.height
                this.oldWidth = this.width
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != event.target.outerWidth) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) * 4 / 5
            this.height = this.width * 9 / 16
        } else if (event.target.innerHeight != event.target.outerHeight) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) - (tmpH - 300) / 12
            this.width = this.height * 16 / 9
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    getSimalation(idClient) {
        const clientParam = '{"clientId":"' + this.idClient + '"}'
        this.isLoading = true
        const clientId = {}
        const result = idClient
        clientId[result] = true
        const resourceDataAccessLog: any = {
            actions: [],
            status: {
                client: {
                    map: clientId,
                },
                clientMail: {
                    paths: {
                        [clientParam]: true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(success => {

                this.JsonSimulation = success['response']['client']['map'][result]
                if (this.JsonSimulation['simulations'] != undefined) {
                    this.arrSimulation = this.JsonSimulation['simulations']
                    this.length = this.arrSimulation.length
                    this.max = this.length - 1
                } else {
                    this.arrSimulation = []
                    this.length = 0
                }
                this.isLoading = false
                this.getShowStatus(this.arrSimulation)
                this.getArrTabSimulation(this.arrSimulation)

                this.arrayTimeSendMail = success['response']['clientMail']['paths'][clientParam].filter(el => {
                    return el['type'] == 'movie'
                })
                this.displaySendAt()
            })
        })
    }

    getArrTabSimulation(arr: any[] = []) {
        this.arrTabSimulation = []
        if (arr.length == 0) {
            this.displaySendAtText = ''
        }
        arr.forEach((el, i) => {
            const json: any = {}
            json['id'] = i
            json['nameSpace'] = i + 1
            this.arrTabSimulation.push(json)
        })
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.arrVideo = []
        arr.forEach((el, i) => {
            if (el['id'] != undefined && el['id'] != '') {
                const url = el['id']
                this.arrVideo.push(url)
                this.arrShowStatus.push(true)
            } else {
                const url: any = ''
                this.arrVideo.push(url)
                this.arrShowStatus.push(false)
            }
        })
    }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        const video: any = document.getElementById('video')
        if (video != undefined) {
            this.valChange = valueUsageChange
            this.durationTime = video.duration
            const curentTime: any = value * this.durationTime / this.senMax
            video.play()
            video.pause()
            video.currentTime = curentTime
        }
    }

    toggleTabSimulationItem(id, index, event) {
        this.TabSimulationClass = id
        this.indexNow = index
        this.durationTime = 0
        this.valChange = 0
        this.uploadImageForm.reset()
        this.displaySendAt()
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    sendMovieMail() {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-send-movie'],
            title: this.en['alert-title-send-mail'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], this.en['alert-save']],
            modifier: 'rowfooter',
            callback: i => {
                if (i === 0) {
                } else if (i === 1) {
                    const clientParam = '{"clientId":"' + this.idClient + '"}'
                    if (this.arrVideo[this.indexNow]) {
                        const arrayParam = this.arrVideo[this.indexNow].split('/')
                        const idMovie = arrayParam[arrayParam.length - 1]
                        const resourceUrl = 'resource'
                        const resourceData = this.restApi.makeResourceObject({
                            actions: [
                                {
                                    type: 'create',
                                    collection: 'clientMail',
                                    value: {
                                        clientId: this.idClient,
                                        requestTime: moment().utc().valueOf(),
                                        status: 'reserved',
                                        type: 'movie',
                                        data: {
                                            movie: {
                                                id: idMovie,
                                            },
                                        },
                                    },
                                },
                            ],
                            status: {
                                clientMail: {
                                    paths: {
                                        [clientParam]: true,
                                    },
                                },
                            },
                        })
                        this.authData.authToken().then(tokenReNew => {
                            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                                this.arrayTimeSendMail = success['response']['clientMail']['paths'][clientParam].filter(el => {
                                    return el['type'] == 'movie'
                                })
                                this.displaySendAt()
                            })
                        })
                    }
                }
            },
        })
    }

    displaySendAt() {
        if (this.arrVideo[this.indexNow]) {
            const arrayParam = this.arrVideo[this.indexNow].split('/')
            const idMovie = arrayParam[arrayParam.length - 1]
            const resultSearch = this.arrayTimeSendMail.find(el => {
                return el['data']['movie']['id'] == idMovie
            })
            if (resultSearch && resultSearch.sendTime) {
                this.displaySendAtText = 'send at ' + moment(resultSearch.sendTime).format('YYYY.MM.DD HH:MM:SS')
            } else {
                this.displaySendAtText = 'not send'
            }
        } else {
            this.displaySendAtText = ''
        }
    }

    removeMovie() {
        this.uploadImageForm.reset()
        this.arrSimulation[this.indexNow]['id'] = ''
        this.getShowStatus(this.arrSimulation)
        this.displaySendAt()
        this.urlThumbail = ''
        const emitSimulation: any = {}
        emitSimulation['simulation'] = this.arrSimulation
        this.clientTopServices.emitChangeArrSimulation(emitSimulation)
    }

    actionVideo() {
        const video: any = document.getElementById('video')
        if (video != undefined && video.paused) {
            video.play()
        } else if (video != undefined && video.played) {
            video.pause()
        }
    }

    addSimulation() {
        if (this.arrTabSimulation.length == 0) {
            this.TabSimulationClass = 'option_0'
            this.indexNow = 0
        }
        const count = this.arrTabSimulation.length
        const jsonAdd: any = {
            id: count,
            nameSpace: count + 1,
        }
        this.arrTabSimulation.push(jsonAdd)
        const json: any = {}
        json['id'] = ''
        this.arrSimulation.push(json)
        this.length = this.arrTabSimulation.length
        if (this.length == 1) {
            this.max = 0
        } else {
            this.max += 1
        }

        const emitSimulation: any = {}
        emitSimulation['simulation'] = this.arrSimulation
        this.clientTopServices.emitChangeArrSimulation(emitSimulation)
    }

    subSimulation() {
        this.arrSimulation.pop()
        if (this.arrSimulation.length == 0) {
            this.displaySendAtText = ''
        }
        this.length = this.arrTabSimulation.length
        this.max -= 1
        const emitSimulation: any = {}
        emitSimulation['simulation'] = this.arrSimulation
        this.clientTopServices.emitChangeArrSimulation(emitSimulation)
        this.getShowStatus(this.arrSimulation)
        this.getArrTabSimulation(this.arrSimulation)
    }

    getUrlImage() {
        if (this.indexNow != undefined) {
            if (undefined != this.arrSimulation && this.arrSimulation.length > 0) {
                const tmp: any = this.arrSimulation[this.indexNow]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        }
        return ''
    }

    handleFileInput(files: FileList, event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0]) // read file as data url
            const excrptFile: any = 'video'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 3000
                this.isLoading = true
                reader.onload = (event: any) => {
                    this.arrShowStatus[this.indexNow] = true
                    if (this.arrSimulation.length == 0) {
                        const json: any = {}
                        json['id'] = 0
                        json['nameSpace'] = 1
                        this.arrTabSimulation.push(json)
                    }
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            this.valChange = 0
                            this.isLoading = false
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            const url = getImageRedirectUrl(success['hash'])
                            this.urlThumbail = getThumbnail(success['hash'])
                            if (this.arrSimulation.length == 0) {
                                this.arrSimulation.push(tmp)
                                this.indexNow = 0
                                this.arrVideo.push(url)
                            } else {
                                this.arrSimulation[this.indexNow] = tmp
                                this.arrVideo[this.indexNow] = url
                            }
                            const emitSimulation: any = {}
                            emitSimulation['simulation'] = this.arrSimulation
                            this.clientTopServices.emitChangeArrSimulation(emitSimulation)
                            const video: any = document.getElementById('video')
                            setTimeout(function() {
                                if (video != undefined) {
                                    video.play()
                                }
                            }, 1000)
                            setTimeout(function() {
                                if (video != undefined) {
                                    video.pause()
                                    video.currentTime = 0
                                }
                            }, 1500)
                            this.displaySendAt()
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/simulation/modal-client-detail-simulation.component.ts